<template>
  <modal :modal-key="'achievement_locked_modal'"
         @close="$emit('close')"
         class="modal--welcomeback modal--zero-balance"
         :header-style="'lock_achievement'"
         :body-style="'achievement'">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_achievements_locked_title }} {{ achievementInfo.achievementLevelName }}</h1>
      <div class="mod_lock_achievement">
        <div class="achievement_icon_container">
          <img class="" :src="achievementInfo.image" alt="">
          <div class="achievement_locked">
            <img class="" src="static/images/locked_icon.svg" alt="">
          </div>
        </div>
      </div>
    </template>
    <template slot="body">
      <p class="modal_second_sub">
        {{ getTranslations.home_modals_achievements_locked_win }}
        {{ achievementInfo.threshold }}
       {{ getTranslations.home_modals_achievements_locked_to_be_called }} "{{ achievementInfo.achievementLevelName }}"
      </p>
      <h2 class="modal_sub">{{ getTranslations.home_modals_achievements_locked_rewarded}}</h2>
      <achievement-reward :achievement-info="achievementInfo" :disable-play="true"/>
    </template>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import AchievementReward from '@/components/home/achievements/AchievementReward';

export default {
  name: 'achievement-locked',
  props: {
    achievementInfo: Object,
  },
  components: {
    Modal,
    AchievementReward,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/achievements/AchievementLocked.vue